import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRouter } from './appRouter';
import './appStyles.css';
import './viewerStyles.css';
import './dashboardStyles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root');

createRoot(container).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>
);
